export enum DynamicValidationTypeEnum {
    Required,
    MinValue,
    MaxValue,
    Range,
    Email
}
